import { UserlistSection } from './UserlistSection';
import { ChatRoom } from 'models/ChatRoom.jsx';
import { Dashboard } from 'components/Dashboard.jsx';
import { Request } from 'components/Request.jsx';
import { ReactChat } from 'react/ReactChat.jsx';

import React from 'react';

class Userlist {

	constructor(chatRoom) {
		this.chatRoom = chatRoom;
		this.users = new Map();
		this.sections = null;
		this.sectionsAddOrder = [];

		this.hasChanges = false;
		this.retrieveFunction = null;
		// Bumped on every add, update or removal, so views can tell the list changed.
		this.version = 0;
	}

	get chatRoomId() {
		if(!this.chatRoom) {
			return null;
		}
		return this.chatRoom.id;
	}

	setSections(sections) {
		for(let section of sections) {
			section.clear();
		}
		this.sections = sections;
		this.sectionsAddOrder = sections;
	}

	setSectionAddOrder(sections) {
		this.sectionsAddOrder = sections;
	}

	setUserlistRetrieveFunction(func) {
		this.retrieveFunction = func;
	}

	retrieveUserlist(options) {
		if(this.retrieveFunction) {
			return this.retrieveFunction(options);
		}
		else {
			return Promise.resolve();
		}
	}

	sort() {
		for(let section of this.retrieveSections()) {
			section.sort();
		}
	}

	addUser(user) {
		if(!user.id) {
			console.error('blank user?', user);
			return;
		}
		this.hasChanges = true;
		this.version++;

		this.applyUserToSection(user);
	}

	/** Whether the user is listed in any section. */
	hasUser(userId) {
		const numericId = Number(userId);
		return !!this.sections && this.sections.some((section) => section.users.has(numericId) || section.users.has(String(userId)));
	}

	removeUser(userId) {
		userId = parseInt(userId);
		// console.log('should be removing ', userId);
		let userlistElement = this.users.get(userId);
		let deleteSuccess = this.users.delete(userId);
		// console.log('delete success', deleteSuccess);
		if(deleteSuccess) {
			this.hasChanges = true;
		}
		this.version++;

		for(const section of this.sections) {
			section.removeUserFromSection({ id: userId });
		}

		if(!userlistElement) {
			// console.log(userId,'not found');
			return;
		}
		userlistElement.remove();
	}

	updateUserlistDisplay(sort = true) {
		if(sort) {
			this.sort();
		}
	}

	retrieveSections() {
		if(this.sections === null) {
			throw new Error('Userlist does not have sections assigned yet!');
		}
		return this.sections;
	}

	applyUserToSection(user) {
		if(!this.sections) {
			throw new Error(`You forgot to set UserlistSection's`);
		}

		let wasAddedToASection = false;
		for(let section of this.sectionsAddOrder) {
			if(section.canHold(user) && !wasAddedToASection) {
				section.addToCounterUserlist(user);
				wasAddedToASection = true;
				continue;
			}
			section.removeUserFromSection(user); // This is to make sre we don't get duplicates if a user gets promoted?
		}
	}

}

export { Userlist };